module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.auth !== null && _vm.auth.user !== null) ? _c('div', [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "name": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.logoutUser($event)
      }
    }
  }, [_vm._v("Logout")])]) : _c('div', [(_vm.error_message !== null) ? _c('p', {
    staticClass: "error-message"
  }, [_vm._v(_vm._s(_vm.error_message))]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.loginUser($event)
      }
    }
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    attrs: {
      "type": "text",
      "name": "email"
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    attrs: {
      "type": "password",
      "name": "password"
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "submit",
      "name": "button"
    }
  }, [_vm._v("login")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-4e81a61f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
// module id = 129
// module chunks = 1